import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaPaw } from "react-icons/fa";

export default function PawTrail() {
  const [paws, setPaws] = useState([]);
  const idRef = useRef(0);
  const lastRef = useRef(0);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return undefined;
    const onMove = (e) => {
      const now = performance.now();
      if (now - lastRef.current < 140) return;
      lastRef.current = now;
      idRef.current += 1;
      const id = idRef.current;
      const rot = Math.random() * 80 - 40;
      setPaws((prev) => [...prev.slice(-7), { id, x: e.clientX, y: e.clientY, rot }]);
      setTimeout(() => {
        setPaws((prev) => prev.filter((p) => p.id !== id));
      }, 900);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div className="pointer-events-none fixed inset-0 z-[70] hidden md:block" aria-hidden="true">
      <AnimatePresence>
        {paws.map((p) => (
          <motion.span
            key={p.id}
            className="absolute text-husko-cyan/60"
            style={{ left: p.x - 8, top: p.y - 8 }}
            initial={{ opacity: 0.55, scale: 0.5, rotate: p.rot }}
            animate={{ opacity: 0, scale: 1.25, y: 12, rotate: p.rot }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <FaPaw size={16} />
          </motion.span>
        ))}
      </AnimatePresence>
    </div>
  );
}
